import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { NavbarIcons } from "./NavbarIcons";
import { UserDropdownMenu } from "./UserDropdownMenu";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

interface DesktopNavProps {
  user: any;
  showArtistContent: boolean;
  showBuyerContent: boolean;
  isAdmin: boolean;
  handleSignOut: () => void;
}

export const DesktopNav = ({
  user,
  showArtistContent,
  showBuyerContent,
  isAdmin,
  handleSignOut,
}: DesktopNavProps) => {
  const { t } = useTranslation('common');
  
  return (
    <div className="hidden lg:flex items-center gap-6">
      <div className="flex items-center gap-2">
        <NavbarIcons user={user} />
        
        <LanguageSwitcher />
        
        {user ? (
          <UserDropdownMenu
            user={user}
            showArtistContent={showArtistContent}
            showBuyerContent={showBuyerContent}
            isAdmin={isAdmin}
            handleSignOut={handleSignOut}
          />
        ) : (
          <Link to="/auth">
            <Button>{t('nav.registerLogin')}</Button>
          </Link>
        )}
      </div>
    </div>
  );
};
